import CreatePolicy from "../../../Components/Policy/CreatePolicy"

export default function CreatePolicies() {
    return (
        
        <CreatePolicy />
    )
}